import { actions } from './Actions';

const initialState = {
  selectedProductPart: null,
  summary: [],
};

export default function MenuReducer(state = initialState, action = {}) {
  switch (action.type) {
    case actions.SET_SELECTED_PRODUCTPART: {
      return {
        ...state,
        selectedProductPart: action.productpart,
      };
    }
    case actions.SET_SUMMARY: {
      return {
        ...state,
        summary: action.summary,
      };
    }
  }
  return state;
}
